<template>
  <div class="page-channel-statistics">
    <div class="statistics-block">
      <div class="filter-field">
        <div class="filter-label">
          渠道码
        </div>
        <div class="filter-contrl">
          <div
            v-if="channelData.dynamic_code_id"
            class="el-button el-button--default el-button--small filter-show"
          >
            {{ channelData.channel_name }}
          </div>
          <el-button
            v-else
            size="small"
            @click="handleSelectGuide"
          >
            添加渠道码以筛选{{ groupData.length > 0 ? `（${groupData.length}个渠道码）` : '' }}
          </el-button>
        </div>
      </div>
      <div class="b-content">
        <div class="b-item">
          <h2>{{ total.new }}</h2>
          今日添加客户数(人)
        </div>
        <div class="b-item">
          <h2>{{ total.total }}</h2>
          总添加客户数(人)
        </div>
      </div>
    </div>

    <div class="statistics-map">
      <el-button-group>
        <el-button
          :type="lineType == 1 ? 'primary' : ''"
          size="small"
          @click="handleClickDrawLine(1)"
        >
          客户总数
        </el-button>
        <el-button
          :type="lineType == 2 ? 'primary' : ''"
          size="small"
          @click="handleClickDrawLine(2)"
        >
          新增客户数
        </el-button>
      </el-button-group>
      <div class="filter-block">
        <div class="leftcon">
          <div class="filter-field">
            <div class="filter-label">
              时间段
            </div>
            <div class="filter-contrl">
              <el-select
                v-model="searchTime"
                size="small"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>

          <div
            v-if="searchTime == -1"
            class="filter-field"
          >
            <div class="filter-label">
              自定义日期
            </div>
            <div class="filter-contrl">
              <el-date-picker
                v-model="beginAndEnd"
                type="daterange"
                size="small"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              />
            </div>
          </div>
        </div>
        <div class="rightcon">
          <el-button
            type="primary"
            size="small"
            @click="onSearch"
          >
            搜索
          </el-button>
          <el-button
            type="primary"
            size="small"
            @click="onReset"
          >
            重置
          </el-button>
        </div>
      </div>

      <div class="report-block">
        <div id="drainage-line-container" />
      </div>
    </div>

    <div class="table-detail">
      <div class="hd">
        表格数据
        <el-button
          class="btn-export"
          type="primary"
          size="small"
          @click="handleClickExport"
        >
          导出
        </el-button>
      </div>
      <div class="td">
        <!-- <el-button-group>
          <el-button
            :type="tableType == 1 ? 'primary' : ''"
            size="small"
            @click="handleClickTable(1)"
          >
            按日期查看
          </el-button>
          <el-button
            :type="tableType == 2 ? 'primary' : ''"
            size="small"
            @click="handleClickTable(2)"
          >
            按导购查看
          </el-button>
        </el-button-group> -->
      </div>
      <div class="bd">
        <SpTableGrid
          ref="tablegrid"
          :columns="[
            {
              name: '日期',
              key: 'day'
            },
            {
              name: '客户总数',
              key: 'total'
            },
            {
              name: '新增客户数',
              key: 'new'
            }
          ]"
          :page-size="7"
          :on-page-change="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { Line } from '@antv/g2plot'
import moment from 'moment'
export default {
  name: '',
  props: ['channelData'],
  data () {
    return {
      groupData: [],
      options: [
        { value: 2, label: '近一周' },
        { value: 3, label: '近一个月' },
        { value: -1, label: '自定义日期' }
      ],
      searchTime: 2,
      line: null,
      lineType: 1, // 1=客户总数； 2=新增客户数
      tableType: 1, // 1=按日期查询； 2=按导购查询
      cacheList: null,
      beginAndEnd: '',
      total: {} //总数据
    }
  },
  watch: {
    channelData (newValue) {
      this.channelData = newValue
    }
  },
  created () {},
  mounted () {
    this.getStatistics()
  },
  methods: {
    async onPageChange (params) {
      const { page, pageSize } = params
      let query = {
        platform: 1
      }
      if (this.searchTime == -1) {
        query['start_date'] = moment(this.beginAndEnd[0]).format('YYYY-MM-DD')
        query['end_date'] = moment(this.beginAndEnd[1]).format('YYYY-MM-DD')
      } else {
        query['dateRange'] = this.searchTime
      }
      console.log(this.groupData, 'this.groupData==')
      if (this.groupData.length > 0) {
        let ids = []
        this.groupData.forEach((v) => {
          ids.push(v.dynamic_code_id)
        })
        query['channel_id'] = ids.join(',')
      } else {
        query['channel_id'] = this.channelData.dynamic_code_id
      }

      let tableQuery = {
        ...query,
        page,
        page_size: pageSize
      }
      const { list, count } = await this.$api.drainage.customerStatistics(tableQuery)
      const drawlist = await this.$api.drainage.customerStatistics(query)

      this.cacheList = drawlist.list
      this.drawLine()
      return {
        list,
        count
      }
    },
    async getStatistics () {
      let params = {
        platform: 1
      }

      if (this.groupData.length > 0) {
        let ids = []
        this.groupData.forEach((v) => {
          ids.push(v.dynamic_code_id)
        })
        params['channel_id'] = ids.join(',')
      } else {
        params['channel_id'] = this.channelData.dynamic_code_id
      }
      const res = await this.$api.drainage.getStatistics(params)
      console.log(res, 'res44')
      this.total = res

      this.handleClickDrawLine(1)
    },
    handleClickDrawLine (type) {
      this.lineType = type
      this.drawLine()
    },
    handleClickTable (type) {
      this.tableType = type
    },
    drawLine () {
      let data = []
      const { cacheList, lineType } = this
      if (lineType == 1 && cacheList) {
        data = cacheList.map((item) => {
          return {
            Date: item.day,
            Value: item.total
          }
        })
      } else if (lineType == 2 && cacheList) {
        data = cacheList.map((item) => {
          return {
            Date: item.day,
            Value: item.new
          }
        })
      }

      if (this.line) {
        this.line.update({
          data,
          padding: 'auto',
          xField: 'Date',
          yField: 'Value'
        })
      } else {
        this.line = new Line('drainage-line-container', {
          data,
          padding: 'auto',
          xField: 'Date',
          yField: 'Value'
        })
        this.line.render()
      }
    },
    async handleSelectGuide () {
      const { data } = await this.$channelCodePicker({
        data: this.groupData
      })
      this.groupData = data

      this.getStatistics()
      this.$refs.tablegrid.fetch()
    },
    onSearch () {
      this.$refs.tablegrid.fetch()
    },
    onReset () {
      this.beginAndEnd = ''
      this.groupData = []
    },
    handleClickExport () {
      let params = {}
      if (this.searchTime == -1) {
        params['start_date'] = moment(this.beginAndEnd[0]).format('YYYY-MM-DD')
        params['end_date'] = moment(this.beginAndEnd[1]).format('YYYY-MM-DD')
      } else {
        params['dateRange'] = this.searchTime
      }
      if (this.groupData.length > 0) {
        params['channel_id'] = this.groupData.join(',')
      } else {
        params['channel_id'] = this.channelData.dynamic_code_id
      }
      params['platform'] = 1
      this.$exportDialog({
        data: {
          url: `${process.env.VUE_APP_BASE_API}/members/member-statistics-export`,
          params
        }
      })
    }
  }
}
</script>

<style scope lang="scss">
.page-channel-statistics {
  .statistics-block {
    @include border-shadow();
    border-radius: 6px;
    padding: 20px;
    background: #fff;
    .filter-field {
      display: flex;
      align-items: center;
      margin: 8px 0;
      .filter-label {
        width: 100px;
      }
    }
    .b-content {
      padding: 20px 0;
      border: 1px solid #b3d8ff;
      background: #ecf5ff;
      display: inline-flex;
      .b-item {
        padding: 0 20px;
        border-right: 1px solid #b3d8ff;
        text-align: center;
        &:last-child {
          border-right: none;
        }
      }
    }
  }

  .statistics-map {
    @include border-shadow();
    border-radius: 6px;
    background: #fff;
    padding: 20px;
    margin-top: 20px;
    .filter-block {
      margin-top: 20px;
      padding: 8px 0;
      border-top: 1px solid $color-border-gray-light;
      border-bottom: 1px solid $color-border-gray-light;
      display: flex;
      .leftcon {
        flex: 1;
      }
      .rightcon {
        width: 140px;
        padding-top: 8px;
      }
      .filter-field {
        display: flex;
        align-items: center;
        margin: 8px 0;
        .filter-label {
          width: 100px;
        }
      }
    }
    .report-block {
      margin-top: 20px;
    }
  }

  .table-detail {
    @include border-shadow();
    border-radius: 6px;
    padding: 20px;
    background: #fff;
    margin: 20px 0;
    .td {
      display: flex;
      justify-content: space-between;
      margin: 20px 0;
    }
    .hd {
      font-size: 16px;
      color: #333;
      font-weight: 600;
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
